import {remCalc} from '../../_utils'

export default {
    baseStyle: {
        outerContainer: {
            width: '100%',
            height: 'auto',
            marginBottom: {
                base: remCalc(0),
                sm: remCalc(0),
                md: remCalc(20),
                lg: remCalc(20),
            },
        },
        categoryHeaderContainer: {
            flexDir: 'column',
            width: '100%',
            h: '100%',
            gap: remCalc(60),
        },
        categoryHeaderInnerContainer: {
            w: '100%',
            flexDir: 'row',
            alignItems: 'center',
            justifyContent: 'flex-start',
        },
        textContainer: {
            flexDir: 'column',
            gap: 'xxxsmall.base',
        },
        textComponent: {
            textStyle: 'head-medium',
            fontWeight: 'medium',
        },
        cardsOuterContainer: {
            w: '100%',
            display: 'block',
        },
        topCardContainer: {
            backgroundSize: 'cover',
            backgroundPosition: 'center',
            backgroundRepeat: 'no-repeat',
            position: 'relative',
            aspectRatio: '16/9',
            width: {
                base: remCalc(280),
                sm: remCalc(280),
                md: remCalc(472),
                lg: '100%',
            },
            height: {
                base: remCalc(157),
                sm: remCalc(157),
                md: remCalc(266),
                lg: 'auto',
            },
            minWidth: {
                base: remCalc(280),
                sm: remCalc(280),
                md: remCalc(472),
                lg: 0,
            },
            maxWidth: {
                base: remCalc(280),
                sm: remCalc(280),
                md: remCalc(472),
                lg: 'none',
            },
            minHeight: {
                base: remCalc(157),
                sm: remCalc(157),
                md: remCalc(266),
                lg: 0,
            },
            maxHeight: {
                base: remCalc(157),
                sm: remCalc(157),
                md: remCalc(266),
                lg: 'none',
            },
            borderRadius: 'large-1',
            overflow: 'hidden',
        },
        imageOverlay: {
            position: 'absolute',
            inset: 0,
            background: 'rgba(0, 0, 0, 0.16)',
            pointerEvents: 'none',
        },
        cardContentContainer: {
            width: '100%',
            position: 'absolute',
            bottom: '0',
            zIndex: 2,
            justifyContent: 'space-between',
            alignItems: 'center',
            paddingTop: 'small-1.lg',
            paddingX: 'xsmall-1.base',
            paddingBottom: 'xsmall-1.base',
        },
        contentContainer: {
            width: '100%',
            flexDir: 'column',
            gap: 'xxxsmall.base',
        },
        sovraTitle: {
            textStyle: 'body-medium',
            fontWeight: 'medium',
        },
        title: {
            textStyle: 'body-medium',
            fontWeight: 'regular',
        },
        buttonContainer: {
            width: remCalc(36),
            height: remCalc(36),
            borderRadius: 'full',
            background: 'background.neutral.default',
            justifyContent: 'center',
            alignItems: 'center',
            zIndex: '2',
            minWidth: remCalc(36),
            padding: '0',
            cursor: 'pointer',

            _hover: {
                background: 'background.neutral.default',
                opacity: 1,
            },

            _focusVisible: {
                border: remCalc(3),
                borderStyle: 'solid',
                borderColor: 'button.border.accessibility-blue-dark',
                outline: 'unset',
                boxShadow: 'unset',
            },
        },
        chevronIcon: {
            width: remCalc(16),
            height: remCalc(16),
        },

        blurStack: {
            position: 'absolute',
            inset: 0,
            zIndex: 1,
            overflow: 'hidden',
            pointerEvents: 'none',
        },

        blurSnapshot: {
            position: 'absolute',
            inset: 0,
            backgroundSize: 'cover',
            backgroundPosition: 'center',
            backgroundRepeat: 'no-repeat',
        },

        bottomScrim: {
            position: 'absolute',
            inset: 0,
            zIndex: 1,
            pointerEvents: 'none',
            background: 'linear-gradient(transparent 45%, rgba(0, 0, 0, 0.75) 100%)',
        },
    },
}
